import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { scheduleCalendarOperations } from 'pages/ScheduleCalendar/duck';
import { requestsOperations } from 'pages/Requests/duck';
import ShiftFieldsComponent from './ShiftFieldsComponent';
import timeUtil from 'pages/ScheduleCalendar/duck/timeUtil';

const mapStateToProps = ({
  scheduleCalendarReducer,
  locationReducer,
  appReducer,
  unregisteredUserReducer,
}) => {
  return {
    allUsers: scheduleCalendarReducer.allUsers.users,
    locationData: locationReducer.location_data,
    channels: appReducer.channels.data,
    unregisteredUsers: unregisteredUserReducer.unregisteredUsers.users,
    locationSettings: appReducer.location.settings,
    roles: appReducer.roles.data,
    skills: appReducer.skills.data,
    channelMembers: appReducer.users.data,
  };
};

const mapDispatchToProps = (dispatch) => {
  
  const addDraftShiftToUserDispatch = (user, startDateTime, endDateTime, jobTitle, locationId, selectedDays, date, fiscalStartDay, roleIds) => {
    const shiftTimeList = timeUtil.getAdjustedShiftTimesForMultipleDays(startDateTime, endDateTime, selectedDays, date, fiscalStartDay);
    shiftTimeList.forEach((startEndTimePair) => {
        const adjustedStartDateTime = startEndTimePair.start;
        const adjustedEndDateTime = startEndTimePair.end;
        if (user.status !== 'unregistered') {
          dispatch(scheduleCalendarOperations.addDraftShiftToUserOnDateOperation(user.owner_id, adjustedStartDateTime, adjustedEndDateTime, jobTitle, locationId, roleIds));
        } else {
          dispatch(scheduleCalendarOperations.addDraftShiftToUnregisteredUserOnDateOperation(user.id, adjustedStartDateTime, adjustedEndDateTime, jobTitle, locationId, roleIds));
        }
    });
  };

  const addDraftOpenShiftToUserDispatch = (currentUserId, startDateTime, endDateTime, jobTitle, locationId, selectedDays, date, fiscalStartDay, channelId, quantity, shiftDescription, roleIds, skillIds) => {
    const shiftTimeList = timeUtil.getAdjustedShiftTimesForMultipleDays(startDateTime, endDateTime, selectedDays, date, fiscalStartDay);
    shiftTimeList.forEach((startEndTimePair) => {
        const adjustedStartDateTime = startEndTimePair.start;
        const adjustedEndDateTime = startEndTimePair.end;
        dispatch(scheduleCalendarOperations.addDraftOpenShiftToUserOnDateOperation(currentUserId, adjustedStartDateTime, adjustedEndDateTime, jobTitle, locationId, channelId, shiftDescription, quantity, roleIds, skillIds));
    });
  };

  const addDraftVTOToUserDispatch = (currentUserId, startDateTime, endDateTime, jobTitle, locationId, selectedDays, date, fiscalStartDay, channelId, quantity, shiftDescription, roleIds, skillIds) => {
    const shiftTimeList = timeUtil.getAdjustedShiftTimesForMultipleDays(startDateTime, endDateTime, selectedDays, date, fiscalStartDay);
    shiftTimeList.forEach((startEndTimePair) => {
        const adjustedStartDateTime = startEndTimePair.start;
        const adjustedEndDateTime = startEndTimePair.end;
        dispatch(scheduleCalendarOperations.addDraftVTOToUserOnDateOperation(currentUserId, adjustedStartDateTime, adjustedEndDateTime, jobTitle, locationId, channelId, shiftDescription, quantity, roleIds, skillIds));
    });
  };

  const updateDraftShiftDispatch = (shift, startDateTime, endDateTime, jobTitle, date, roleIds) => {
    // Adjust the start and end date based on the day
    const adjustedStartDateTime = timeUtil.dayLightSavingsAdjustedDateTime(date, date, startDateTime);
    var adjustedEndDateTime = timeUtil.dayLightSavingsAdjustedDateTime(date, date, endDateTime);
    
    // Handle overnight shift case (where end time is after midnight)
    if (timeUtil.isOvernightShift(startDateTime, endDateTime, date)) {
      const nextDay = date.clone().add(1, 'days');
      adjustedEndDateTime = timeUtil.dayLightSavingsAdjustedDateTime(nextDay, date, endDateTime);
    }

   dispatch(scheduleCalendarOperations.updateDraftShiftOperation(shift.id, adjustedStartDateTime, adjustedEndDateTime, jobTitle, roleIds));
 }

 const updateDraftOpenShiftDispatch = (shiftId, currentUserId, startDateTime, endDateTime, jobTitle, locationId, date, channelId, quantity, shiftDescription, roleIds, skillIds) => {
    deleteDraftBulkShiftDispatch(shiftId, locationId)
    const adjustedStartDateTime = timeUtil.dayLightSavingsAdjustedDateTime(date, date, startDateTime);
    var adjustedEndDateTime = timeUtil.dayLightSavingsAdjustedDateTime(date, date, endDateTime);
    dispatch(scheduleCalendarOperations.addDraftOpenShiftToUserOnDateOperation(currentUserId, adjustedStartDateTime, adjustedEndDateTime,jobTitle, locationId, channelId, shiftDescription, quantity, roleIds, skillIds));
 }

 const updateDraftVTOShiftDispatch = (shiftId, currentUserId, startDateTime, endDateTime, jobTitle, locationId, date, channelId, quantity, shiftDescription, roleIds, skillIds) => {
  deleteDraftBulkShiftDispatch(shiftId, locationId);
  const adjustedStartDateTime = timeUtil.dayLightSavingsAdjustedDateTime(date, date, startDateTime);
  var adjustedEndDateTime = timeUtil.dayLightSavingsAdjustedDateTime(date, date, endDateTime);
  dispatch(scheduleCalendarOperations.addDraftVTOToUserOnDateOperation(currentUserId, adjustedStartDateTime, adjustedEndDateTime, jobTitle, locationId, channelId, shiftDescription, quantity, roleIds, skillIds));
 }

 const deleteDraftBulkShiftDispatch = (shiftId, locationId) => {
  dispatch(scheduleCalendarOperations.deleteShiftOperation(shiftId, locationId));
};

 const updatePublishedOpenShiftDispatch = (openShift, totalAvailable, content, position, roleIds, skillIds ) => {
    dispatch(scheduleCalendarOperations.updatePublishedBulkShiftOperation(openShift.id, totalAvailable, content, position, skillIds));
 }

 const updatePublishedVTOShiftDispatch = (vtoShift, totalAvailable, content, position, roleIds, skillIds ) => {
  dispatch(scheduleCalendarOperations.updatePublishedBulkShiftOperation(vtoShift.id, totalAvailable, content, position, skillIds));
}

const reassignTeamShiftDispatch = (shift, targetUserId) => {
  deleteDraftBulkShiftDispatch(shift.id, shift.location_id);
  dispatch(scheduleCalendarOperations.addShiftToUserOnDateOperation(targetUserId, shift.start_at, shift.end_at, shift.primary_job, shift.location_id));
 }

  const fetchChannelMembers = (channelId) => {
    dispatch(requestsOperations.fetchChannelMembers(channelId));
  };

  return {
    addDraftOpenShiftToUserDispatch,
    addDraftShiftToUserDispatch,
    updateDraftShiftDispatch,
    updatePublishedOpenShiftDispatch,
    updateDraftOpenShiftDispatch,
    reassignTeamShiftDispatch,
    addDraftVTOToUserDispatch,
    updatePublishedVTOShiftDispatch,
    updateDraftVTOShiftDispatch,
    fetchChannelMembers,
  };
};

const ShiftFieldsComponentContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)((props) => {
  const {
    allUsers,
    locationData,
    channels,
    unregisteredUsers,
    applicants,
    locationSettings,
    skills,

    addDraftShiftToUserDispatch,
    addDraftOpenShiftToUserDispatch,
    updateDraftShiftDispatch,
    updatePublishedOpenShiftDispatch,
    updateDraftOpenShiftDispatch,
    reassignTeamShiftDispatch,
    addDraftVTOToUserDispatch,
    updatePublishedVTOShiftDispatch,
    updateDraftVTOShiftDispatch,
    fetchChannelMembers,

    presentedShift,
    cancelModal,
    prepareToDeleteShift,
    prepareToCopyShift,
    date,
    userToAddShiftTo,
    isOpenShiftConfigured,
    roles,
    isVTOConfigured,
    creationType,
    channelMembers,
    } = props;

  // Debug: Log when channelMembers changes from Redux
  useEffect(() => {
    // console.log('[ShiftFieldsComponentContainer] channelMembers from Redux:', channelMembers?.length || 0, 'members');
    if (channelMembers && channelMembers.length > 0) {
      // console.log('[ShiftFieldsComponentContainer] channelMembers sample:', channelMembers.slice(0, 3));
    }
  }, [channelMembers]);

  return <ShiftFieldsComponent
    allUsers={allUsers}
    locationData={locationData}
    channels={channels}
    unregisteredUsers = {unregisteredUsers}
    applicants = {applicants}
    locationSettings = {locationSettings}
    isVTOConfigured={isVTOConfigured}
    creationType={creationType}
    skills={skills}
    channelMembers={channelMembers}
    addDraftOpenShiftToUserDispatch={addDraftOpenShiftToUserDispatch}
    addDraftShiftToUserDispatch={addDraftShiftToUserDispatch}
    updateDraftShiftDispatch={updateDraftShiftDispatch}
    updatePublishedOpenShiftDispatch={updatePublishedOpenShiftDispatch}
    updateDraftOpenShiftDispatch={updateDraftOpenShiftDispatch}
    reassignTeamShiftDispatch={reassignTeamShiftDispatch}
    addDraftVTOToUserDispatch={addDraftVTOToUserDispatch}
    updatePublishedVTOShiftDispatch={updatePublishedVTOShiftDispatch}
    updateDraftVTOShiftDispatch={updateDraftVTOShiftDispatch}
    fetchChannelMembers={fetchChannelMembers}
    
    presentedShift={presentedShift}
    cancelModal={cancelModal}
    prepareToDeleteShift={prepareToDeleteShift}
    prepareToCopyShift={prepareToCopyShift}
    date={date}
    userToAddShiftTo = {userToAddShiftTo}
    isOpenShiftConfigured = {isOpenShiftConfigured}
    roles={roles}
   />
});

export default ShiftFieldsComponentContainer;